module.exports = __webpack_public_path__ + "static/media/Receivership Order dated October 12, 2023.5bfacb5e.pdf";